import { MenuItem, TextField } from "@mui/material";
import { useLocalization } from "@fluent/react";
import { DepartmentNotificationTargetEnum } from "../companyDepartmentsSlice";

type DepartmentNotificationTargetFieldProps = {
    value: DepartmentNotificationTargetEnum;
    onChange: (value: DepartmentNotificationTargetEnum) => void;
    fullWidth?: boolean;
    disabled?: boolean;
};

export const DepartmentNotificationTargetField = ({
    value,
    onChange,
    fullWidth = true,
    disabled = false
}: DepartmentNotificationTargetFieldProps) => {
    const { l10n } = useLocalization();

    return (
        <TextField
            select
            label={l10n.getString(
                "company-department-notification-target",
                null,
                "Strategia powiadomień"
            )}
            value={value}
            onChange={(e) => onChange(e.target.value as DepartmentNotificationTargetEnum)}
            fullWidth={fullWidth}
            disabled={disabled}
        >
            <MenuItem value={DepartmentNotificationTargetEnum.MembersOnly}>
                {l10n.getString(
                    "company-department-notification-target-members-only",
                    null,
                    "Tylko członkowie działu"
                )}
            </MenuItem>

            <MenuItem value={DepartmentNotificationTargetEnum.DepartmentEmailOnly}>
                {l10n.getString(
                    "company-department-notification-target-department-email-only",
                    null,
                    "Tylko email działu"
                )}
            </MenuItem>

            <MenuItem value={DepartmentNotificationTargetEnum.MembersAndDepartmentEmail}>
                {l10n.getString(
                    "company-department-notification-target-members-and-email",
                    null,
                    "Członkowie + email działu"
                )}
            </MenuItem>
        </TextField>
    );
};